$(window).on('load', function () {
  const $window = $(this);
  const $animationObjs = $('.js-animation');
  let wh = $window.height();
  let ws = $window.scrollTop();
  animationStart($animationObjs, ws, wh);

  $window.on({
    scroll: $.throttle(250, function () {
      ws = $(this).scrollTop();
      animationStart($animationObjs, ws, wh);
    }),
    resize: function () {
      wh = $(this).height();
      ws = $(this).scrollTop();
    }
  });
});

function animationStart ($animationObjs, windowScroll, windowHeight) {
  $animationObjs.each(function (index, obj) {
    const objTop = $(obj).offset().top;
    if (objTop < windowScroll + windowHeight) {
      $(obj).addClass('js-animationStart');
    }
  });
}
